<template>
    <section class="content">
      <box >
        <div slot="body">
          <ul class="nav nav-tabs">
            <li class="active" id="dados"><a href="javascript:;" @click="mudarAtivo('dados')">DADOS DO PRODUTO</a></li>
            <li class="" id="funcionamento"><a href="javascript:;" @click="mudarAtivo('funcionamento')">FUNCIONAMENTO</a></li>
          </ul>
          <br>

          <!--     DADOS DO PRODUTO     -->
          <div v-show="tabAtiva == 'dados'">
            <div class="row">
                <div class="col-md-4">
                    <h4>Nome</h4>
                    <input v-model="nome" type="text" class="form-control">
                    <label v-if="nome===''">*Campo Obrigatório</label>
                </div>
                <div class="col-md-2">
                    <h4>Codigo Interno (ERP)</h4>
                    <input v-model="codigo_interno" type="number" class="form-control">
                </div>
                <div class="col-md-6">
                  <h4>Imagem </h4>
                  <input type="file" id="file-input">
                  <p id="status">Please select a file</p>
                </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h4>Descrição</h4>
                <textarea v-model="descricao" rows="1" cols="12" class="form-control"></textarea>
                <label v-if="descricao===''">*Campo Obrigatório</label>
              </div>
            </div>
            <div class="row" v-for="(linha, index) in formularioPreco">
                <div class="col-md-3">
                    <h4>Preço</h4>
                    <input v-model="linha.preco" v-money="money" value="0" min="0" step="0.01" data-number-to-fixed="2" data-number-stepfactor="100" class="form-control currency"/>
                </div>
                <div class="col-md-3">
                    <h4>Categoria</h4>
                    <select class="form-control" v-model="linha.id_cardapio">
                        <option v-for="c in categories" v-bind:value="c.id">{{c.nome}}</option>
                    </select>
                    <label v-show="linha.id_cardapio===0">*Campo Obrigatório</label>
                </div>
                <div class="col-md-3 adicionaPreco" v-if="index === 0">
                  <a @click="adicionaPreco">Adicionar Preço</a>
                </div>
                <div class="col-md-3 adicionaPreco" v-else>
                  <a @click="removerPreco(index)"><i class="fa fa-times" aria-hidden="true"></i></a>
                </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-1">
                <h4>Ativo</h4>
                  <toggle-button 
                    v-model="ativo"
                    :color="color" 
                    :sync="true" />
              </div>
              <div class="col-md-3">
                <h4>Produtos permite adicionais</h4>
                <toggle-button 
                  v-model="permiteadicionais"
                  :sync="true" />
              </div>
            </div><br>
            <div class="row" v-show="permiteadicionais" v-for="(catAdicional, index) in adicionais">
              <div class="col-md-3">
                <h4>Categoria adicionais</h4>
                <select class="form-control" v-model="catAdicional.categoria">
                  <option v-for="c in categories" v-bind:value="c.id">{{c.nome}}</option>
                </select>
              </div>
              <div class="col-md-3">
                <h4>Quantidade Permitida</h4>
                <input v-model="catAdicional.qtde" type="number" class="form-control">
              </div>
              <div class="col-md-3">
                <h4>Obrigatório</h4>
                <toggle-button 
                  v-model="catAdicional.exigido"
                  :sync="true" />
              </div>
              <div class="col-md-3 adicionaPreco" v-if="index === 0">
                <a @click="addAdicionais"><i class="fa fa-plus-circle" aria-hidden="true"></i></a>
              </div>
              <div class="col-md-3 adicionaPreco" v-else>
                <a @click="removerAdicional(index)"><i class="fa fa-times" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>

          <!-- FUNCIONAMENTO -->
          <div v-show="tabAtiva === 'funcionamento'">
            <div class="row">
              <div class="col-md-4">
                  <h4>Definir funcionamento</h4>
                  <toggle-button 
                    v-model="possuiFuncionamento"
                    :color="color" 
                    :sync="true" />
              </div>
            </div><br><br>
            <ul type="none" v-show="possuiFuncionamento">
              <li class="row">
                <ul type="none">
                  <li v-for="linha in funcionamento">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" v-model="linha.ativo" :true-value="true" :false-value="false">
                        {{linha.dia.toUpperCase()}}
                      </label>
                    </div>
                    <ul type="none">
                      <div v-show="linha.ativo">
                        <input type="time" v-model="linha.hr_abertura_1"/> às <input type="time" v-model="linha.hr_fechamento_1"/> &nbsp  - &nbsp <input type="time" v-model="linha.hr_abertura_2"/> às <input type="time" v-model="linha.hr_fechamento_2"/>
                      </div>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>

            <!-- <div class="row" v-show="possuiFuncionamento" v-for="f in funcionamento">
              <div class="col-md-2"><input type="checkbox" class="form-check-input" v-model="f.ativo" :true-value="true" :false-value="false"> <label for="">{{f.dia.toUpperCase()}}</label></div>
              <div class="col-md-2" style="display: flex">Das <input type="time" v-model="f.hr_abertura_1"/> às <input type="time" v-model="f.hr_fechamento_1"/></div>
              <div class="col-md-2" style="display: flex">Das <input type="time" v-model="f.hr_abertura_2"/> às <input type="time" v-model="f.hr_fechamento_2"/></div><br><br>
            </div> -->
          </div>

          <br><br>
          <router-link class="pageLink" to="/produtos">
                  <button class="btn btn-danger" >Cancelar</button>
          </router-link>
          <button class="btn btn-success" @click="gravar" v-show="habilitaGravar" >
            <i class="fa fa-check">  Gravar</i>
          </button>
          <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
        </div>
      </box>
    </section>
</template>
<script>
import axios from 'axios'
import Box from './Box' // importando modal
import {VMoney} from 'v-money'
import s3 from '../../services/s3'

export default {
  name: 'NovoProduto',
  directives: {money: VMoney},
  components: {
    'box': Box
  },
  data () {
    return {
      possuiFuncionamento: false,
      funcionamento: [
        {
          ativo: true,
          dia: 'domingo',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        },
        {
          ativo: true,
          dia: 'segunda',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        },
        {
          ativo: true,
          dia: 'terca',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        },
        {
          ativo: true,
          dia: 'quarta',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        },
        {
          ativo: true,
          dia: 'quinta',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        },
        {
          ativo: true,
          dia: 'sexta',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        },
        {
          ativo: true,
          dia: 'sabado',
          hr_abertura_1: '00:00',
          hr_abertura_2: '00:00',
          hr_fechamento_1: '00:00',
          hr_fechamento_2: '00:00'
        }
      ],
      tabAtiva: 'dados',
      allCategories: [],
      formularioPreco: [{
        preco: 0,
        id_cardapio: 0
      }],
      categories: [],
      nome: '',
      descricao: '',
      codigo_interno: null,
      categoria_selecionada: '',
      preco: 0,
      imagem: '',
      alteracao: false,
      id_alteracao: 0,
      gravando: false,
      money: {
        thousands: ',',
        decimal: '.',
        // prefix: 'R$ ',
        precision: 2,
      },
      permiteadicionais: false,
      ativo: true,
      adicional: null,
      adicionais: [{
        categoria: null,
        qtde: 0,
        exigido: false
      }]
    }
  },
  created () {
    console.log('ativo ', this.tabAtiva)
    this.getCategories()
    if(this.$route.params.id) {
      console.log('alterando');
      this.alteracao = true
      this.id_alteracao = this.$route.params.id
      this.getProdutos(this.id_alteracao)
      this.getTabelaPreco(this.id_alteracao)      
      this.getFuncionamento(this.id_alteracao)
    }
  },
  computed: {
    habilitaGravar () {
      if (this.nome != '' && this.descricao != '' && !this.gravando) {
        for (let i in this.formularioPreco) {
          if (this.formularioPreco[i].id_cardapio === 0) {
            return false
          }
        }
        return true
      }
      return false
    }
  },
  methods: {
    mudarAtivo (id) {
      console.log('id => ', id)
      $('.active').removeClass('active')
      document.getElementById(id).className = 'active'
      this.tabAtiva = id
    },
    adicionaPreco() {
      this.formularioPreco.push({
        preco: 0,
        categoria: 0
      })
    },
    removerPreco (index) {
      this.formularioPreco.splice(index, 1)
    },
    addAdicionais() {
      this.adicionais.push({
        categoria: null,
        qtde: 0,
        exigido: false
      })
    },
    removerAdicional (index) {
      this.adicionais.splice(index, 1)
    },
    getCategories () {
      axios.get(`${this.$store.state.api}categorias?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.categories = response.data
        // console.log(this.categories)
        //this.ajustaCategorias()
      })
    },
    ajustaCategorias () {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (this.verificaFolha(this.allCategories[i].id)) {
          this.categories.push(this.allCategories[i])
        } else {
          if (this.allCategories[i].children.length > 0) {
            for (var j = 0; j < this.allCategories[i].children.length; j++) {
              if (this.verificaFolha(this.allCategories[i].children[j].id)) {
                this.categories.push(this.allCategories[i].children[j])
              }
            }
          }
        }
      }
    },
    verificaFolha (id) {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (id === this.allCategories[i].pai) {
          return false
        } else {
          for (var j = 0; j < this.allCategories[i].children.length; j++) {
            if (id === this.allCategories[i].children[j].pai) {
              return false
            }
          }
        }
      }
      return true
    },
    getFuncionamento (id) {
      axios.get(this.$store.state.api+ 'produtos/funcionamento/' + id).then((response) => {
        console.log('funcionamento ', response) 
        if(response.data.length > 0) {
          this.possuiFuncionamento = true
          this.funcionamento = response.data
        } 
      })
    },
    getTabelaPreco(id) {
      axios.get(this.$store.state.api+ 'tabelapreco/' + id).then((response) => {
        this.formularioPreco = []
        for (let i in response.data) {
          response.data[i].preco = response.data[i].preco.toFixed(2)
          if(response.data[i].id_categoria) response.data[i].id_cardapio = response.data[i].id_categoria 
          this.formularioPreco.push(response.data[i])
        }
        console.log('tabela preco -> ', this.formularioPreco) 
      })
    },
    getProdutos (id) {
      axios.get(`${this.$store.state.api}produtos/${id}`).then(response => {
        let products = response.data[0]

        this.nome = products.nome
        this.descricao = products.descricao
        this.imagem = products.url_imagem
        this.codigo_interno = products.codigo_interno,
        this.permiteadicionais = products.permiteadicionais,
        this.ativo = products.ativo
        this.adicional = products.adicionais
        if(products.ProdutosAdicionais && products.ProdutosAdicionais.length > 0) {
          this.adicionais = products.ProdutosAdicionais.map(element => ({ categoria: element.cardapio_id.toString(), exigido: element.exigido, qtde: parseInt(element.qtde_permitida) }))
        }

        this.$store.commit('SET_ID_ALTERACAO', 0)
      })
    },
    gravar () {
      this.gravando = true
      const files = document.getElementById('file-input').files;
      const file = files[0];

      if(file != null) {
        var blob = file.slice(0, file.size, file.type); 
        let newFile = new File([blob], `${this.$store.state.empresa_id}_produto_${Date.now()}_${file.name.replace(' ', '_')}`, {type: file.type});
        console.log('new file ==> ', newFile)
        s3.getSignedRequest(newFile).then(res => {
          this.imagem = res.url
          this.gravarProduto();
        }).catch(err => {
          alert('Erro ao salvar imagem');
        })
      } else {
        // if(this.alteracao) {
          this.gravarProduto();
        // } else {
          // alert('É necessário selecionar uma imagem.');
          // this.gravando = false
        // }
      }
          // this.imagem = 'https://s3-sa-east-1.amazonaws.com/baita-batata/baitabatata-logo.jpg'
          // this.gravarProduto()
    },
    getObjEnvio () {
      let objRetorno = [], campos = {}
      campos.nome = this.nome
      campos.descricao = this.descricao
      campos.url_imagem = this.imagem
      campos.permiteadicionais = this.permiteadicionais
      campos.ativo = this.ativo
      if (this.codigo_interno !== '') campos.codigo_interno = this.codigo_interno
      // if (this.adicional) campos.adicional = this.adicional
      if(this.permiteadicionais) campos.adicionais = this.adicionais
      campos.alteracao = this.alteracao
      campos.id = this.id_alteracao
      campos.tabelapreco = []
      for(let i in this.formularioPreco) {
        let tabelapreco = {}
        tabelapreco.preco = parseFloat(this.formularioPreco[i].preco)
        tabelapreco.categoria = this.formularioPreco[i].id_cardapio
        campos.tabelapreco.push(tabelapreco)
      }
      campos.empresa = this.$store.state.empresa_fb_id
      objRetorno.push(campos)
      return objRetorno
    },
    gravarProduto(){
      let objRetorno = this.getObjEnvio()
      console.log(objRetorno)
      axios.post(this.$store.state.api+'produtos/insert', objRetorno).then(response => {
        console.log('response ==> ', response)
          if (response.data.success) {
            if(this.possuiFuncionamento) {
              if(this.alteracao) {
                axios.put(this.$store.state.api + 'produtos/funcionamento', {
                  produto: response.data.produto,
                  funcionamento: this.funcionamento
                }).then((res) => {
                  this.atualizarCron()
                  this.$swal({
                          position: 'top-end',
                          type: 'success',
                          title: 'Incluido com sucesso',
                          showConfirmButton: false,
                          timer: 1500
                        })   
                      this.$router.go(-1)
                })
              } else {
                axios.post(this.$store.state.api + 'produtos/funcionamento', {
                  produto: response.data.produto,
                  funcionamento: this.funcionamento
                }).then((res) => {
                  this.atualizarCron()
                  this.$swal({
                          position: 'top-end',
                          type: 'success',
                          title: 'Incluido com sucesso',
                          showConfirmButton: false,
                          timer: 1500
                        })   
                      this.$router.go(-1)
                })
              }
            } else {
              axios.delete(`${this.$store.state.api}produtos/funcionamento/${response.data.produto}`, { }).then((res) => {
                this.atualizarCron()
                this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Incluido com sucesso',
                    showConfirmButton: false,
                    timer: 1500
                  })   
                this.$router.go(-1)
              });
            }
          } else {
            this.$swal(
              'Ops!',
              'O produto não foi gravado.',
              'error'
            )
          }
        })
    },
    atualizarCron() {
      axios.get('https://senhor-destino.herokuapp.com/restart')
    }
  }
}
</script>
<style>
.adicionaPreco {
  margin-top: 3.5%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// NovoProduto.vue?7f6f6c18